export const getInitials = (user) => {
  const first = user && user.firstname ? user.firstname.charAt(0) : "";
  const last = user && user.lastname ? user.lastname.charAt(0) : "";
  const initials = first.toUpperCase() + last.toUpperCase();
  return initials;
};
